import { getEventList, getEventDetail, getNotificationList } from '../api/event'
import {
  deepCopy,
  formatAggEventList,
  formatEventDetail,
  formatNotificationList,
} from '../lib/utils'
import { DEFAULT_PAGINATION } from '../lib/constant'

const state = {
  pendingEventList: [],
  pendingTotal: 0,
  acknowledgedEventList: [],
  acknowledgedTotal: 0,
  doneEventList: [],
  doneTotal: 0,
  mutedEventList: [],
  mutedTotal: 0,
  endedEventList: [],
  endedTotal: 0,
  eventDetail: {},
  alertCount: 0, // 新的警报总数量
}

const mutations = {
  SET_DATAS(state, { key, value }) {
    state[key] = value
  },
  SET_EVENT_DATA(state, params = {}) {
    const { tabKey, zone, camera, data, total, current = 1 } = params

    const eventList = state[`${tabKey}EventList`],
      currentIndex = eventList.findIndex((item) => {
        return item.zone === zone && item.camera === camera
      })

    if (current === 1) {
      state[`${tabKey}EventList`][currentIndex].data = data
    } else {
      state[`${tabKey}EventList`][currentIndex].data =
        eventList[currentIndex].data.concat(data)
    }

    if (total !== undefined)
      state[`${tabKey}EventList`][currentIndex].total = total
  },
}

const actions = {
  // 聚合的数据
  async getNotificationData({ commit }, params = {}) {
    const { tabKey, ...other } = params

    const { total, data } = await getNotificationList(other).catch(() => {})
    const eventList = formatNotificationList(data)

    commit('SET_DATAS', { key: `${tabKey}EventList`, value: eventList })
    commit('SET_DATAS', { key: `${tabKey}Total`, value: total })
  },
  // 单列表数据
  async getEventData({ commit }, params = {}) {
    const { tabKey, zone, camera, ...other } = params,
      conditions = {
        zone,
        ...other,
      }
    
    if (camera) {
      conditions.camera = [camera] // 后端暂时只支持数组形式
    }

    if (!params.pagination) {
      conditions.pagination = deepCopy(DEFAULT_PAGINATION)
    }

    try {
      const { data, total } = await getEventList(conditions)
      const formatttedAggEventList = formatAggEventList(data)
      const newEventList = state[`${tabKey}EventList`].concat(formatttedAggEventList)
      commit('SET_DATAS', { key: `${tabKey}EventList`, value: newEventList })
      commit('SET_DATAS', { key: `${tabKey}Total`, value: total })
    } catch (error) {
      console.error('Error fetching event list:', error)
      throw error // Re-throw to let component handle it
    }

    // const setEventParams = {
    //   tabKey,
    //   zone,
    //   camera,
    //   data: eventData,
    //   total,
    //   current,
    // }

    // commit('SET_EVENT_DATA', setEventParams)
  },
  async getEventDetail({ commit, dispatch }, params = {}) {
    const { eventID, docID } = params
    if (!eventID) {
      throw new Error('eventID is required')
    }

    try {
      // Clear existing detail first to avoid stale data
      commit('SET_DATAS', { key: 'eventDetail', value: null })

      // Get configurations first
      await dispatch('options/getLayeringConfig', {}, { root: true })

      // Get event details
      const data = await getEventDetail({ eventID })
      if (!data) {
        throw new Error('Failed to fetch event detail')
      }

      // Format and store the data
      const eventDetail = formatEventDetail(data, docID)
      commit('SET_DATAS', { key: 'eventDetail', value: eventDetail })
      
      return eventDetail
    } catch (error) {
      console.error('Error fetching event detail:', error)
      throw error // Re-throw to let component handle it
    }
  },
  // 设置数据
  setDatas({ commit }, data) {
    commit('SET_DATAS', data)
  },
  setEventData({ commit }, data) {
    commit('SET_EVENT_DATA', data)
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
}
